(function () {
  const customStyles = `
    button ._formCloseButton_1684x_4 {
      border: none !important;
      background: none !important;
      cursor: pointer;
      padding: 10px 15px !important;
      margin-top: 5px !important;
    }
    button ._teaserHeading_trejf_28 {
      font-weight: 500 !important;
      font-family: 'Inter' !important;
      color:rgb(18, 75, 77) !important;
    }
    ._formCloseButton_1684x_4 svg {
      fill:rgb(54, 64, 69) !important;
      fill-opacity: 0.65 !important;
    }
    ._teaserContainer_trejf_5 {
      gap: 8px !important;
      padding: 7px 11px 7px 23px !important;
      border-radius: 40px !important;
    }
    .appEmbed {
      padding-bottom: 26.5px !important;
    }

    @media screen and (max-width: 749px) {
      button ._teaserHeading_trejf_28 {
        font-size: 14px !important;
      }
      #app-embed {
        width: auto !important;
        max-width: calc(100vw - 16px) !important;
        box-sizing: border-box !important;
      }
      button._formCloseButton_1684x_4 {
        margin-top: 0px !important;
      }
      button._teaserContainer_trejf_5 {
        display: inline-flex !important;
        align-items: center !important;
        flex-wrap: nowrap !important;
        width: fit-content !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        gap: 3px !important;
        padding: 7px 3px 7px 15px !important;
        border-radius: 40px !important;
      }
      ._teaserHeading_trejf_28 {
        display: inline-block !important;
        white-space: nowrap !important;
        margin: 0 !important;
        font-size: 12px !important;
        line-height: 1.1 !important;
      }
      ._formCloseButton_1684x_4 {
        flex: 0 0 auto !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
#app-embed {
    z-index: 1400 !important;
    }

      ._formCloseButton_1684x_4 svg {
        width: 10px !important;
        height: 10px !important;
      }

      button ._formCloseButton_1684x_4 {
 
    margin-top: 0px !important; 
}

    }
  `;

  function injectIntoShadow(shadowRoot) {
    if (shadowRoot.querySelector('style[data-custom-gg]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-custom-gg', 'true');
    style.textContent = customStyles;
    shadowRoot.appendChild(style);
  }

  function checkForShadowRoots(node) {
    if (node.nodeType !== 1) return;
    if (node.shadowRoot) injectIntoShadow(node.shadowRoot);
    node.querySelectorAll && node.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) injectIntoShadow(el.shadowRoot);
    });
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => m.addedNodes.forEach(checkForShadowRoots));
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('*').forEach(el => {
    if (el.shadowRoot) injectIntoShadow(el.shadowRoot);
  });
})();


document.addEventListener('keydown', function (e) {
  const isSearchInput = e.target.matches(
    'input[type="search"], input[name="q"], predictive-search input'
  );

  if (isSearchInput && e.key === 'Enter') {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();
    return false;
  }
}, true);

document.addEventListener('keyup', function (e) {
  const isSearchInput = e.target.matches(
    'input[type="search"], input[name="q"], predictive-search input'
  );

  if (isSearchInput && e.key === 'Enter') {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();
    return false;
  }
}, true);

document.addEventListener('submit', function (e) {
  const form = e.target.closest('form[action*="/search"]');

  if (form) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();
    return false;
  }
}, true);
